import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { titleStyle, titleStyleSI, dividerStick } from "./header.module.scss";
import { isMobile } from "@/helpers/utils";
import { IMAGE_BASE_PATH } from "@/config/config";
import Image from "next/image";
import { Button } from "@/components/core/form";

const Heading = ({
  title,
  headerWidth,
  mAlign,
  upsellTitle,
  proposalEdit,
  onEditBtnClick,
  expiringPolicyToDate,
  showEditBtn,
  onBackBtnClick,
  step,
}) => {
  const [mobileView, setMobileView] = useState(false);
  const [hideEditBtn, sethideEditBtn] = useState(false);
  const isMobileView = window.innerWidth <= 767;

  useEffect(() => {
    const handleResize = () => {
      setMobileView(isMobile(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (step === 5) {
      sethideEditBtn(true);
    } else {
      sethideEditBtn(false);
    }
  }, [step]);

  return (
    <>
      {upsellTitle ? (
        <div className="row">
          <div className="col-md-12">
            <div
              className={classNames(
                titleStyleSI,
                `${headerWidth}`,
                mobileView ? `text-${mAlign}` : ""
              )}
            >
              {title}
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="container d-flex justify-content-between align-items-center">
            {proposalEdit && !showEditBtn && (
              <Button
                type="button"
                className={classNames("round-btn", "mr-md-2", "mb-2", {
                  "mr-2": !mobileView, // Add margin-right 2 only for non-mobile views
                })}
                secondary={true}
                active={false}
                bottomFixed={false}
                onClick={onBackBtnClick}
                // style={{ maxWidth: "50px", padding: "10px" }} // Set maximum width and padding to make the button smaller
              >
                <Image
                  src={`${IMAGE_BASE_PATH}/images/arrow-backward.svg`}
                  alt="X"
                  width={24}
                  height={24}
                />
              </Button>
            )}
            <div
              className={classNames(
                titleStyle,
                `${headerWidth}`,
                mobileView ? `text-${mAlign}` : "",
                proposalEdit ? "p-0" : ""
              )}
            >
              {title}
              {proposalEdit && (
                <>
                  {!showEditBtn && !hideEditBtn && (
                    <>
                      <span
                        className={classNames(
                          mobileView ? "d-none" : "",
                          dividerStick
                        )}
                      >
                        |
                      </span>
                      <span className={classNames(mobileView ? "d-block" : "")}>
                        <Image
                          src={`${IMAGE_BASE_PATH}/images/edit-pen.svg`}
                          alt="X"
                          width={12}
                          height={12}
                          className="edit-pen"
                        />
                        <button className="link-btn" onClick={onEditBtnClick}>
                          Edit Proposal
                        </button>
                      </span>
                    </>
                  )}
                  <div className="sub-head-text">
                    <span>Medicare Plus</span>{" "}
                    <span className={classNames(mobileView ? "d-none" : "")}>
                      |
                    </span>{" "}
                    <span className={classNames(mobileView ? "d-block" : "")}>
                    Renewal Due Date:{" "}
                      <span>{expiringPolicyToDate}</span>
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Heading.propTypes = {
  title: PropTypes.string,
  headerWidth: PropTypes.string,
  mAlign: PropTypes.string,
  upsellTitle: PropTypes.bool,
  proposalEdit: PropTypes.bool,
  showEditBtn: PropTypes.bool,
  onEditBtnClick: PropTypes.func,
  onBackBtnClick: PropTypes.func,
  expiringPolicyToDate: PropTypes.string,
  step: PropTypes.number,
};

Heading.defaultProps = {
  headerWidth: "col-md-6 col-sm-12",
  mAlign: "center",
};

export default React.memo(Heading);
